import { render } from "./Booking.vue?vue&type=template&id=4068c756"
import script from "./Booking.vue?vue&type=script&lang=js"
export * from "./Booking.vue?vue&type=script&lang=js"
script.render = render

export default script